import { Alert, Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { vinErrorText } from './vinExtractionErrors';

/** "‹ Previous failed / Next failed ›" through the batch's failed cars; disabled at the ends (E22). */
const CarFailedNav = ({ nav }) => {
    const { t } = useTranslation('vinExtraction');
    const navError = nav.error === 'invalid' ? t('cars.invalidResponse') : nav.error && vinErrorText(t, nav.error);

    return (
        <Flex vertical gap={spacing[1]} role="navigation" aria-label={t('drawer.nav.aria')}>
            {navError && <Alert type="error" showIcon message={t('drawer.nav.loadFailed')} description={navError} />}
            <Flex justify="space-between" gap={spacing[2]}>
                <Button onClick={nav.previous} disabled={!nav.hasPrevious} loading={nav.loading && nav.hasPrevious}>
                    {t('drawer.nav.previous')}
                </Button>
                <Button onClick={nav.next} disabled={!nav.hasNext} loading={nav.loading && nav.hasNext}>
                    {t('drawer.nav.next')}
                </Button>
            </Flex>
        </Flex>
    );
};

export default CarFailedNav;
